var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function LogoIconsWindowsIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 11.0001V5.93109L4 6.85778L3.99315 11.0001H9.5ZM3.983 17.1367L9.5 18.0736V13.0001H3.98984L3.983 17.1367ZM20.0442 4.1545L11.5 5.59411V11.0001H20.0256L20.0442 4.1545ZM20.0202 13.0001H11.5V18.4133L20.0015 19.8572L20.0202 13.0001ZM2 17.5018V6.49832C2 5.72783 2.58704 5.05081 3.34604 4.93696L20.3573 2.08527C21.2373 1.95327 22 2.6157 22 3.50444V20.4957C22 21.3833 21.234 22.0463 20.3573 21.9148L3.34604 19.0631C2.58378 18.9488 2 18.2755 2 17.5018Z", fill: "" })));
}
export var LogoIconsWindowsIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: LogoIconsWindowsIconInner }, props))); };
//# sourceMappingURL=LogoIconsWindowsIcon.js.map